// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createHook, createStore } from '@atlassian/react-sweet-state';
import { actions } from './actions.tsx';
import type { State } from './types.tsx';

const initialState: State = {
	isLoading: false,
	isSuccess: false,
	error: null,
};

const store = createStore({
	actions,
	initialState,
	name: 'annoucement-banner-user-dismiss',
});

export const useUserDismiss = createHook(store);
export const useUserDismissActions = createHook(store, {
	selector: null,
});
